export default __webpack_public_path__ + "static/media/spint-selected.c43a30c8.svg";